import React, { useState } from 'react'
import config from '../../config.json'
import Login from './Login'
import RedefinirSenha from './RedefinirSenha'
import { Button, Container, Grid, Paper, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { NovaConta } from './NovaConta'

const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: `${theme.shadows[3]}, 0px -4px 1px -2px ${theme.palette.primary[theme.palette.mode === 'dark' ? 'dark' : 'main']}`,
    maxWidth: 500,
    width: 'calc(100% - 64px)',
  },
  title: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    margin: 15,
  },
  title1: {
    fontWeight: '800',
  },
  title2: {
    fontWeight: '500',
  },
  container: {
    padding: 10,
  },
  linkButton: {
    textTransform: 'none',
    display: 'block',
  },
  span: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'justify',
  },
}))

const Index = () => {
  const classes = useStyles()
  const [tela, setTela] = useState('login')
  const [esqueciSenha, setEsqueciSenha] = useState(false)

  const esqueciMinhaSenha = () => setEsqueciSenha(true)
  const voltarTelaLogin = () => setEsqueciSenha(false)
  const novoCadastro = () => setTela('cadastro')
  const [telaValidaToken, setTelaValidaToken] = useState({
    open: false,
    idUsuario: '',
  })

  return (
    <div
      style={{
        backgroundColor: '#eeeeee',
        width: '100%',
        minHeight: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          className="max-w-[500px] shadow-lg"
          style={{ width: 'calc(100% - 64px)', borderRadius: 20, padding: 15 }}
        >
          <span
            color="primary"
            className="m-[12px] flex items-center justify-center text-4xl font-bold text-[#007BFF]"
          >
            <img src={config.imgSistema} alt={`Logo ${config.titulo}`} />
          </span>
          <hr />
          <Container className={classes.container}>
            <Grid container spacing={2}>
              {esqueciSenha ? (
                <>
                  <Grid item xs={12}>
                    <span className="flex items-baseline justify-center text-justify">
                      Esqueceu sua senha? Informe seu e-mail para solicitar a
                      recuperação de senha!
                    </span>
                  </Grid>
                  <RedefinirSenha voltarTelaLogin={voltarTelaLogin} />
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      className={classes.linkButton}
                      onClick={voltarTelaLogin}
                    >
                      Login
                    </Button>
                  </Grid>
                </>
              ) : (
                <>
                  {tela === 'login' ? (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body1" className={classes.span}>
                          <span></span>
                        </Typography>
                      </Grid>
                      <Login
                        setTela={setTela}
                        setTelaValidaToken={setTelaValidaToken}
                        telaValidaToken={telaValidaToken}
                      />
                      <div className="flex w-full justify-between p-2">
                        <button
                          className="block bg-transparent p-1 text-sm text-primary-main hover:shadow-md"
                          onClick={esqueciMinhaSenha}
                        >
                          Esqueci minha senha
                        </button>
                        <button
                          onClick={novoCadastro}
                          className="block bg-white p-1 text-sm text-primary-main hover:shadow-md"
                        >
                          Registrar
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body1" className={classes.span}>
                          Registrar Novo Usuário
                        </Typography>
                      </Grid>
                      <NovaConta
                        setTela={setTela}
                        setTelaValidaToken={setTelaValidaToken}
                        telaValidaToken={telaValidaToken}
                      />
                      <div className="flex w-full justify-between p-2">
                        <button
                          onClick={() => setTela('login')}
                          className="block bg-white p-1 text-sm text-primary-main hover:shadow-md"
                        >
                          Já tem conta? Faça login
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Container>
        </Paper>
      </div>
      <footer
        style={{
          width: '100%',
          padding: '15px 0',
          textAlign: 'center',
          backgroundColor: '#f5f5f5',
          borderTop: '1px solid #ddd',
          justifyContent: 'space-between',
        }}
      >
        <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>
          3Sync Apps e Sistemas
          <a
            href="mailto:contato@3sync.com.br"
            style={{ color: '#007BFF', padding: '1vw' }}
          >
            contato@3sync.com.br
          </a>
        </p>
      </footer>
    </div>
  )
}

export default Index
